import { ActivityGroupDTORead, StatisticGroupDTORead } from "../models/ActivityDTO";
import { ApiResult } from "../models/ApiResult";
import { ApiRequest } from "./service.base";


export class StatisticGroupRequest  extends ApiRequest<StatisticGroupDTORead,ApiResult> {
    constructor(endpoint: string, token: string) {
        super(endpoint, token)
    }
}